import { useQuery } from 'apollo-3';

import { getPersonalizedDiscountCode } from 'GraphQL/query/PersonalizedDiscountCode.query';

const usePersonalizedDiscountCode = (classroomId, apolloProps) => {
  const { data, loading, error } = useQuery(getPersonalizedDiscountCode, {
    variables: { classroomId },
    ...apolloProps,
  });
  return {
    data: data?.sfFoGetPersonalizedDiscountCodeByClassroomId,
    loading,
    error,
  };
};

export default usePersonalizedDiscountCode;
